import { Link } from "react-router-dom";
import { ShieldX } from "lucide-react";
import BrandLogo from "../components/shared/BrandLogo";

export default function Unauthorized() {
  return (
    <div className="min-h-[100dvh] flex items-center justify-center bg-gradient-to-br from-[#eef5fb] to-white dark:from-slate-950 dark:to-slate-900 px-4">

      <div className="w-full max-w-sm text-center animate-in fade-in zoom-in duration-300">

        {/* Logo */}
        <div className="flex flex-col items-center mb-4">
          <BrandLogo variant="auto" className="w-24 h-24 object-contain animate-logo" />

          <h1 className="mt-2 text-xl font-bold text-brand">
            Kéves App
          </h1>
        </div>

        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className="h-16 w-16 rounded-[16px] bg-red-100 dark:bg-red-900/30 flex items-center justify-center shadow-sm">
            <ShieldX size={30} className="text-red-600 dark:text-red-400" />
          </div>
        </div>

        <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-100 mb-2">
          Acceso no autorizado
        </h2>

        <p className="text-sm text-slate-500 dark:text-slate-400 mb-6 leading-relaxed px-2">
          Tu cuenta aún no tiene acceso a la aplicación.
          Solicita autorización para poder ingresar.
        </p>

        {/* Card */}
        <div className="bg-white dark:bg-slate-900 rounded-[20px] border border-slate-100 dark:border-slate-800 shadow-[0_4px_16px_rgba(1,46,104,0.08)] dark:shadow-[0_4px_16px_rgba(0,0,0,0.3)] p-5 space-y-3">

          <Link
            to="/request-access"
            className="block w-full bg-brand text-white p-3 rounded-[14px] font-semibold transition-all duration-200 ease-out hover:brightness-90 active:scale-[0.98]"
          >
            Solicitar acceso
          </Link>

          <Link
            to="/login"
            className="block text-xs text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300 transition"
          >
            Volver al inicio
          </Link>

        </div>

      </div>
    </div>
  );
}
